import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { FanPageView } from "@/components/fanpage/FanPageView";

export default function PagePreview() {
  const { id } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/pages/${id}`).then(({ data }) => setPage(data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center text-center px-6" data-testid="preview-not-found">
        <p className="text-slate-400">Page not found.</p>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-white/30 border-t-white animate-spin" />
      </div>
    );
  }

  return (
    <div data-testid="page-preview-view">
      <div className="bg-amber-500 text-black text-center text-xs font-bold py-1.5" data-testid="preview-draft-banner">
        DRAFT PREVIEW — this page is not published yet. Only you can see this.
      </div>
      <FanPageView page={page} scale="full" />
    </div>
  );
}
